import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, fullAdminOnly = false }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-[40vh] grid place-items-center text-sm font-mono text-slate-500">
        Loading…
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (fullAdminOnly && user.role !== "admin") return <Navigate to="/admin" replace />;
  if (adminOnly && user.role !== "admin" && user.role !== "staff") return <Navigate to="/" replace />;
  return children;
}
